import type { ApplicationFormFieldData } from '@/schemas/v2'

/** tel フィールドのバリデーション正規表現: 先頭 + 許可・半角数字のみ・16桁以内 */
const TEL_PATTERN = /^\+?[0-9]{1,16}$/

/** email フィールドのバリデーション正規表現 */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/**
 * 動的応募フォームの単一フィールドをバリデーションし、エラーメッセージ文字列を返す。
 * エラーなし（OK）の場合は null を返す。
 *
 * @param field  フィールド定義（inputType / isRequired を参照）
 * @param value  現在の入力値
 */
export function validateApplicationFormFieldValue(
  field: ApplicationFormFieldData,
  value: string | string[],
): string | null {
  const isCheckbox = field.inputType === 'checkbox'
  const strValue = typeof value === 'string' ? value : ''
  const isBlank = strValue.trim() === ''

  // checkbox と テキスト系で必須チェックを分離
  // （checkbox の value は配列のため strValue は常に '' になり isBlank では判定できない）
  if (isCheckbox) {
    if (field.isRequired && (!Array.isArray(value) || value.length === 0)) {
      return `${field.label}を選択してください`
    }
    return null
  }

  // テキスト系: 必須チェック（select は「選択してください」、その他は「入力してください」）
  if (field.isRequired && isBlank) {
    if (field.inputType === 'select') return `${field.label}を選択してください`
    return `${field.label}を入力してください`
  }

  // 空白の場合は形式チェックをスキップ（任意フィールドで未入力は OK）
  if (isBlank) return null

  // 電話番号: 先頭 + 許可・半角数字のみ・16桁以内
  if (field.inputType === 'tel' && !TEL_PATTERN.test(strValue)) {
    return '半角数字で入力してください'
  }

  // メールアドレス: 形式チェック
  if (field.inputType === 'email' && !EMAIL_PATTERN.test(strValue)) {
    return 'メールアドレスの形式が正しくありません'
  }

  return null
}
